import React, { useState, useEffect } from 'react';
import { roleMapping } from '../../../helpers/transformations';
import './role-checkbox-list.scss'

export const roles = roleMapping;

export default function RoleCheckboxList({ initialRoles = [], onChange }) {
    const [selectedRoles, setSelectedRoles] = useState(initialRoles);

    const sortedRoleEntries = Object.entries(roles)
        .map(([id, name]) => ({ id: Number(id), name }))
        .sort((a, b) => a.id - b.id);

    // Re-initialize only when initialRoles values actually change (not just reference).
    // Bailing out (returning prev) prevents the re-render that would otherwise feed
    // back into the parent and cause a flicker loop.
    useEffect(() => {
        setSelectedRoles(prev => {
            const sortedPrev = [...prev].sort((a, b) => a - b);
            const sortedNext = [...initialRoles].sort((a, b) => a - b);
            const same =
                sortedPrev.length === sortedNext.length &&
                sortedPrev.every((v, i) => v === sortedNext[i]);
            return same ? prev : initialRoles;
        });
    }, [initialRoles]);

    // Call onChange directly on user interaction — not via useEffect — so the
    // programmatic reset above never triggers a parent notification.
    const toggleRole = (roleId) => {
        const updated = selectedRoles.includes(roleId)
            ? selectedRoles.filter(id => id !== roleId)
            : [...selectedRoles, roleId];
        setSelectedRoles(updated);
        onChange?.(updated);
    };

    return (
        <div className="role-checkbox-list">
            {sortedRoleEntries.map(role => (
                <label key={role.id} className="role-checkbox-item">
                    <input
                        type="checkbox"
                        checked={selectedRoles.includes(role.id)}
                        onChange={() => toggleRole(role.id)}
                    />
                    <span>{role.name}</span>
                </label>
            ))}
        </div>
    );
}
